import { Space } from "antd";
import { useEffect, useState } from "react";
import DefaultFormParserLayout from "../../../components/Layouts/default-form-parser-layout";
import Button from "../../../components/UI/Button";
import SelectInput from "../../../components/UI/SelectInput";
import SmartSearch from "../../../components/UI/SmartSearch";
import { useLoading } from "../../../context/LoadingProvider/useLoading";
import { DateFormatEnum } from "../../../enums/dateFormatEnum";
import useSmartSearchParams from "../../../hooks/useSmartSearchParams";
import { getReport } from "../../../services/reports";
import { Output } from "../../../services/types";
import endpoints from "../../../utils/endpoints";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import RangePicker from "../../../components/UI/RangePicker";
import dayjs from "dayjs";

type Form = {
  absolute_or_percentage_select: string;
};

const valueSelectOptions = [
  { name: "Absolute", value: "absolute" },
  { name: "Percentage", value: "percentage" },
];

function ReportRevenueByDayOfWeek() {
  const LAST_WEEK = dayjs().subtract(1, "week");
  const TODAY = dayjs();

  const loading = useLoading();

  const [params, setParams] = useSmartSearchParams();

  const [search, setSearch] = useState("");

  const [form, setForm] = useState<Form>({
    absolute_or_percentage_select: valueSelectOptions[0].value,
  });

  const [validSearch, setValidSearch] = useState(false);
  const [report, setReport] = useState("");
  const [timeInterval, setTimeInterval] = useState([LAST_WEEK, TODAY]);

  const refreshReport = async (output: Output = Output.HTML) => {
    loading.addLoading();

    const lastWeek = timeInterval[0];
    const today = timeInterval[1];

    const revenueByDayOfWeekParams: Record<string, any> = {
      output,
      beginDate: lastWeek.format(DateFormatEnum.YEAR_MONTH_DAY),
      endDate: today.format(DateFormatEnum.YEAR_MONTH_DAY),
      absolute_or_percentage_select: form.absolute_or_percentage_select,
    };

    if (params.id) {
      const id = createIdFromSmartSearchParams(params);
      revenueByDayOfWeekParams[id] = params.id;
    }

    if (!!form.absolute_or_percentage_select) {
      revenueByDayOfWeekParams.event = form.absolute_or_percentage_select;
    }

    const res = await getReport(
      revenueByDayOfWeekParams,
      endpoints.getRevenueByDayOfWeek,
      output
    );

    if (Output.isHTML(output)) {
      setReport(res);
    }

    loading.removeLoading();
  };

  return (
    <DefaultFormParserLayout html={report}>
      <Space direction="horizontal" size="small" wrap>
        <SmartSearch
          label="Smart Search"
          searchBy={["distributor", "charity", "location"]}
          onChange={(e: string) => setSearch(e)}
          status="active,closed"
          value={search}
          onValidSearch={setValidSearch}
          validOnEmpty
          onObjValueChange={(e: any) => setParams({ ...params, ...e })}
          autoFocus
        />
        <SelectInput
          onSelectChange={(e) =>
            setForm({ ...form, absolute_or_percentage_select: e?.value ? e.value : e })
          }
          options={valueSelectOptions}
          value={form.absolute_or_percentage_select}
          label="Values"
        />
        <RangePicker
          label="Date Interval"
          defaultValue={[LAST_WEEK, TODAY]}
          onChange={(e: any) => setTimeInterval(e)}
          allowClear={false}
        />
        <Button
          onClick={() => refreshReport()}
          type="primary"
          disabled={!validSearch}
        >
          Refresh
        </Button>
      </Space>
    </DefaultFormParserLayout>
  );
}

export default ReportRevenueByDayOfWeek;
